var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.94535 16.0176V5.66324H0.72477V16.0176H3.94535ZM2.31774 4.27805C3.35664 4.27805 4.18776 3.4123 4.18776 2.37341C4.18776 1.36914 3.35664 0.538023 2.31774 0.538023C1.31348 0.538023 0.482361 1.36914 0.482361 2.37341C0.482361 3.4123 1.31348 4.27805 2.31774 4.27805ZM15.9619 16.0176H15.9965V10.3383C15.9965 7.56789 15.3732 5.42084 12.118 5.42084C10.5597 5.42084 9.52076 6.28658 9.07057 7.08307H9.03594V5.66324H5.95388V16.0176H9.17446V10.8924C9.17446 9.54179 9.41687 8.26049 11.0791 8.26049C12.7413 8.26049 12.776 9.7842 12.776 10.9962V16.0176H15.9619Z",
    fill: "#4B4B4B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.ffda15f8200dc42f2cfb2fcf786a9ddb.svg";
export { ForwardRef as ReactComponent };